import React from 'react';

import cls from './PrevFileFrameLoader.module.css';

export const PrevFileFrameLoader = () => (
    <div className={cls.container}>
        <div className={cls.spinner}>
            <div className={cls.bounce1} />
            <div className={cls.bounce2} />
            <div className={cls.bounce3} />
        </div>
    </div>
);
